/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

/**
 * Collection of helper functions for writing your component styles in our theming system.
 * Pass in your style and it will return an object with the appropriate CSS selector wrapping it.
 */

const wrapWithActiveSelector = (style: object) => ({
  '&:active': style
});

const wrapWithHoverSelector = (style: object) => ({
  '&:hover': style
});

const wrapWithFocusSelector = (style: object) => ({
  '&:focus': style
});

const wrapWithFocusVisibleSelector = (style: object) => ({
  '&:focus-visible': style
});

const wrapWithVisitedSelector = (style: object) => ({
  '&:visited': style
});

const wrapWithNotActiveSelector = (style: object) => ({
  '&:not(:active)': style
});

const wrapWithPseudoHoverSelector = (style: object) => ({
  '@media': {
    '(hover: hover)': {
      selectors: {
        '&:hover:not(:active)': style
      }
    }
  }
});

export {
  wrapWithActiveSelector,
  wrapWithHoverSelector,
  wrapWithFocusSelector,
  wrapWithFocusVisibleSelector,
  wrapWithVisitedSelector,
  wrapWithNotActiveSelector,
  wrapWithPseudoHoverSelector
};
